import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MarketerService {
  private marketer = new BehaviorSubject<any>(null);

  constructor() { }
  sendMarketer(marketerModel: any) {
    this.marketer.next( marketerModel );
  }
  getMarketer(): Observable<any> {
    return this.marketer.asObservable();
  }
}
